import { Address } from '../address.model';
import { NewRegistrationQuestion } from '../registration-questions.model';

export class UserFromBE {
  id?: number;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: null;
  company?: string;
  active?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  password?: string;
  tenantID?: number;
  tenant?: Tenant;
  session?: string;
  emailVerified?: boolean;
  verificationHash?: string;
  dateOfEmailVerification?: string;
  lastActivity?: string;
  photoID?: number;
  photoThumbnail?: string;
  dateInvited?: string;
  invitedByUserID?: number;
  inviteHash?: string;
  dateAccepted?: string;
  roles?: Role[];
  userType?: string;
  marketing?: boolean;
  privacyPolicy?: boolean;
  title?: string;
  titleAfterName?: string;
  telephone?: string;
  shortcvID?: number;
  shortcv?: ShortCV;
  PersonalDataID?: number;
  longcv?: Longcv;
  longcvID?: number;
  userAttachments?: UserAttachments[];
  userPreferences?: string;
  language?: string;
  aiMatching?: boolean;
  aiParsing?: boolean;
  status?: string;
}

export class ModifyUserFromBE extends UserFromBE {
  mlmInviteCode?: string;
  mlmInviteCodeUrl?: string;
  mlmInvitedByUserId?: number;
}

export class UserProfile {
  id?: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  gender?: string;
  title?: string;
  titleAfterName?: string;
  birthDate?: string;
  telephone?: string;
  languages?: Language[];
  skills?: Skill[];
  highSchoolEducations?: HighSchoolEducation[];
  universityEducations?: UniversityEducation[];
  workExperiences?: WorkExperience[];
  projects?: Project[];
  driversLicenses?: DriversLicenses;
  aiMatching?: boolean;
  aiParsing?: boolean;
  educationLevelID?: number;
  // Legacy fields (kept for backward compatibility)
  jobType?: string | string[] | any[];
  jobCategory?: string | string[] | any[];
  selfDescription?: string | string[];
  // New fields from backend refactoring
  jobCategories?: Array<{id: number; categoryKey: string}>;
  employmentTypes?: Array<{id: number; employmentTypeKey: string; sortOrder?: number; active?: boolean}>;
  jobPositions?: Array<{id: number; positionKey: string; uuid: string; jobCategoryId: number}>;
  address?: Address;
}


export class GoogleRegister {
  isGoogle: boolean;
  name: string;
  email: string;
  emailVerified: boolean;
  uid: string;
  idToken: string;
}

export class ChangePassword {
  oldPassword: string;
  newPassword: string;
  newPasswordAgain: string;
}

export class Tenant {
  id?: number;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: null;
  name?: string;
  logo?: string;
  active?: boolean;
  tenantType?: string;
  companyID?: string;
  taxID?: string;
  vat?: string;
  inRegister?: string;
  companyRepresentativeName?: string;
  companyRepresentativeEmail?: string;
  employeesNumber?: string;
  tenantCharacteristic?: string;
  tenantBenefits?: string[];
  tenantAddresses: TenantAddress[];
  tenantLogoId?: number;
}
export class TenantAddress {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: null;
  TenantID: number;
  streetName: string;
  streetNumber: string;
  city: string;
  zip: string;
  poBox: string;
  country: string;
  billing: boolean;
}

export class Role {
  id?: number;
  value?: string;
}

export class ShortCV {
  id?: number;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: null;
  cityCountry?: string;
  questionsID?: number;
  questions?: NewRegistrationQuestion;
}
export class Longcv {
  id?: number;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: null;
  gender?: string;
  title?: string;
  titleAfterName?: string;
  birthDate?: string;
  telephone?: string;
  PersonalDataLanguages?: PersonalDataLanguage[];
  workExperiences?: WorkExperience[];
  universityEducations?: UniversityEducation[];
  highSchoolEducations?: HighSchoolEducation[];
  languages?: Language[];
  skills?: Skill[];
  projects?: Project[];
  driversLicenses?: DriversLicenses;
  address?: Address
}

export class HighSchoolEducation {
  id?: number;
  highSchoolName?: string;
  fieldOfStudy?: string;
  city?: string;
  country?: string;
  startDate?: string;
  endDate?: string;
  candidateAttachment?: CandidateAttachment;
  attachmentID?: number;
  educationLevelID?: number;
  personalDataID?: number;
}

export class CandidateAttachment {
  id?: number;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  url?: string;
  fileType?: string;
  type?: string;
  fileName?: string;
  fileSize?: string | number;
}

export class PersonalDataLanguage {
  id?: number;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  pdLanguageName?: string;
  pdLanguageLevel?: string;
  personalDataID?: number;
}

export class UniversityEducation {
  id?: number;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  universityName?: string;
  fieldOfStudy?: string;
  city?: string;
  country?: string;
  startDate?: string;
  endDate?: string;
  candidateAttachment?: CandidateAttachment;
  attachmentID?: number;
  educationLevelID?: number;
  current?: boolean;
  personalDataID?: number;
}

export class Language {
  id?: number;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  language: string;
  level: string;
  personalDataID?: number;
}


export class Skill {
  id?: number;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  skillName: string;
  level: string;
  personalDataID?: number;
}

export class WorkExperience {
  id?: number;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  position?: string;
  employer?: string;
  city?: string;
  country?: string;
  startDate?: string;
  endDate?: string;
  current?: boolean;
  personalDataID?: number;
  description?: string;
}

export class UserAttachments {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  url: string;
  fileType: string;
  type: string;
  fileName: string;
  entityID: number;
  model: string;
  tenant: Tenant;
  tenantID: number;
}

export class UserPreferences {
  CandidatesPreferences?: string;
  JobOffersPreferences?: string;
  UserId?: number;
  id?: number;
  Language?: string;
}

export class TablePreferences {
  columns?: string[];
  sortDirection: string;
  sortColumn?: string;
  statuses?: string[];
  textSearch?: string;
  dateStart?: string;
  dateEnd?: string;
}

export class CandidatesPreferences {
  candidateColumns?: string[];
  sortDirection?: string;
  sortColumns?: string;
}

export class JobOffersPreferences {
  jobOffersColumns?: string[];
  sortDirection?: string;
  sortColumns?: string;
}

export class Project {
  id?: number;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  position?: string;
  title?: string;
  duration?: number;
  country?: string;
  personalDataID?: number;
}

export class DriversLicenses {
  id?: number;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  driversLicenses?: string; // JSON array string like '["AM","A1","B"]'
  personalDataID?: number;
}

export class Resume extends CandidateAttachment {
  resumeFile?: any;
  resumeLanguage?: string;
  attachmentId?: string;
}

export class LanguageExtended extends Language {
  edit?: boolean;
  isAiParsed?: boolean;
}

export class WorkExperienceExtended extends WorkExperience {
  // Frontend properties
  edit?: boolean;
  isAiParsed?: boolean;
}

export class SkillExtended extends Skill {
  // Frontend properties
  edit?: boolean;
  isAiParsed?: boolean;
}

export class UniversityEducationExtended extends UniversityEducation {
  // Frontend properties
  isCurrentlyStudying?: boolean;
  edit?: boolean;
  isAiParsed?: boolean;
}

export class HighSchoolEducationExtended extends HighSchoolEducation  {
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  edit?: boolean;
  isAiParsed?: boolean;
}

export class ProjectExtended extends Project {
  edit?: boolean;
  isAiParsed?: boolean;
}

export class UserProfileExtended extends UserProfile {
  override languages?: LanguageExtended[];
  override skills?: SkillExtended[];
  override highSchoolEducations?: HighSchoolEducationExtended[];
  override universityEducations?: UniversityEducationExtended[];
  override workExperiences?: WorkExperienceExtended[];
  override projects?: ProjectExtended[];
}

export interface ProfileSettings {
  userStatuses?: string[];
}
